/*
 * `compat/device.js`
 *  -  device間の互換性対応
 *
 * 使用方法:
 *  - import { functionName } from "./device.js";
 */


import {mediaQuery} from "../utils/index.js";


/**
 * スクロールバーなどを除いた画面の高さを正確に取得（主にスマホデバイス用）
 */
export function setViewport() {
  const vw = document.documentElement.clientWidth * 0.01; // スクロールバーを含まないviewportサイズ
  const vh = window.innerHeight * 0.01; // スクロールバーを含むviewportサイズ

  // ズーム倍率の取得
  const zoom = window.outerWidth / window.innerWidth;
  console.log(`Viewport set to ${vw}px`);
  document.documentElement.style.setProperty("--vw", `${vw}px`);
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  document.documentElement.style.setProperty("--zoom", `${zoom}`);
}


/**
 * PC→SPなどのデバイス変更が発生した際に再読み込み
 */
export function switchMediaReload(currentWindowWidth, currentDevice) {
  const nextWindowWidth = window.innerWidth;
  const nextDevice = mediaQuery(nextWindowWidth);

  if (nextDevice !== currentDevice) {
    location.reload();
  }
}

